// extracted by mini-css-extract-plugin
export var avatarContainer = "_5n-1";
export var largeAvatarContainer = "_5n-2";
export var smallAvatarContainer = "_5n-0";